/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnDestroy, type OnInit, Component, Injector, Input } from '@angular/core';
import { EventService, SlideWindowAbstract } from '@dm/core';
import { SWITCH } from 'app/config';
import { type Subscription } from 'rxjs';

import { SystemUpgradeComponent } from '../system-upgrade-panel/system-upgrade.component';
import { UpgradeModeE } from '../upgrade.const';
import { UpgradeService } from '../upgrade.service';
import { UpgradeComponent } from '../upgrade-panel/upgrade.component';
import { UpgradeStrService } from '../upgrade-str.service';

@Component({
    selector: 'app-upgrade-choose-mode',
    templateUrl: './upgrade-choose-mode.component.html',
    styleUrls: ['./upgrade-choose-mode.component.scss'],
})
export class UpgradeChooseModeComponent extends SlideWindowAbstract implements OnInit, OnDestroy {
    @Input() upgrade: UpgradeComponent;
    @Input() systemUpgrade: SystemUpgradeComponent;

    i18n = this.str.i18n;

    UpgradeModeE = UpgradeModeE;

    SWITCH = SWITCH;

    // 是否展示系统升级
    isShowSystemUpgrade = false;

    sub$: Subscription;
    isJa = this.i18nService.language === 'ja';
    constructor(
        injector: Injector,
        public str: UpgradeStrService,
        private upgradeService: UpgradeService,
        private eventService: EventService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.pageReady = true;
        this.windowVisible = true;
        this.initDeviceInfo();
    }

    showUpgradeEntry(upgradeMode: UpgradeModeE): void {
        this.closeArgs.upgradeMode = upgradeMode;
        this.hide();
    }

    initDeviceInfo(): void {
        this.sub$ = this.eventService.subscribe('systemInfoUpdate', this.getIsShowUpgrade);
        this.getIsShowUpgrade();
    }

    /**
     * 是否展示系统升级， 高端release屏蔽系统升级入口
     */
    getIsShowUpgrade = (): void => {
        this.isShowSystemUpgrade = this.upgradeService.ifShowUpgrade();
        if (this.isShowSystemUpgrade !== undefined) {
            this.sub$.unsubscribe();
        }
    };

    ngOnDestroy(): void {
        this.sub$.unsubscribe();

        // super.ngOnDestroy()?
    }
}
